"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: Object.getOwnPropertyDescriptor(all, name).get
    });
}
_export(exports, {
    get ArtifactResponse () {
        return ArtifactResponse;
    },
    get ListArtifactsResponse () {
        return ListArtifactsResponse;
    },
    get RenderResponse () {
        return RenderResponse;
    }
});
const _zod = require("zod");
const _models = require("@performyard/models");
const _responsehelpers = require("../helpers/response-helpers");
const ArtifactResponseItem = _zod.z.object({
    _id: _responsehelpers.ResponseObjectId,
    company_id: _responsehelpers.ResponseObjectId,
    name: _zod.z.string(),
    created_via: _zod.z.literal("ai_chat"),
    createdBy: _responsehelpers.ResponseObjectId.nullish(),
    outputType: _zod.z.enum([
        "answer",
        "table",
        "chart"
    ]),
    // nullish: Mongo stores an explicitly-undefined field (answer artifacts save no query) as
    // null, not as an absent key — see CreateArtifactRequest for the corresponding write-side note.
    query: _models.ArtifactReportQuery.nullish(),
    output: _models.ArtifactOutput,
    // Optional: new artifacts omit it entirely; only older docs still carry it.
    chatHistory: _zod.z.array(_models.ArtifactChatMessage).optional(),
    createdAt: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ]),
    updatedAt: _zod.z.union([
        _zod.z.date(),
        _zod.z.string()
    ])
});
const ArtifactResponse = _zod.z.object({
    artifact: ArtifactResponseItem
});
const ListArtifactsResponse = _zod.z.object({
    artifacts: _zod.z.array(ArtifactResponseItem)
});
const RenderResponse = _zod.z.discriminatedUnion("outputType", [
    _zod.z.object({
        outputType: _zod.z.literal("answer"),
        answer: _zod.z.string(),
        underlyingQuery: _zod.z.string(),
        // Answers are never row-bounded — always false, kept alongside table/chart so the client
        // can read `truncated` without branching on outputType first.
        truncated: _zod.z.literal(false)
    }),
    _zod.z.object({
        outputType: _zod.z.literal("table"),
        title: _zod.z.string(),
        columns: _zod.z.array(_zod.z.object({
            id: _zod.z.string(),
            label: _zod.z.string()
        })),
        rows: _zod.z.array(_zod.z.record(_zod.z.string(), _zod.z.unknown())),
        rowCount: _zod.z.number(),
        // True when the underlying result had more rows than the display cap (see
        // emit-page-bound.ts) — the first `rowCount` are shown, the rest are dropped.
        truncated: _zod.z.boolean()
    }),
    _zod.z.object({
        outputType: _zod.z.literal("chart"),
        chartType: _zod.z.enum([
            "bar",
            "line",
            "pie"
        ]),
        title: _zod.z.string(),
        labels: _zod.z.array(_zod.z.string()),
        categoryLabel: _zod.z.string(),
        valueLabel: _zod.z.string(),
        // null = empty group (Chart.js renders a gap), deliberately not coerced to 0.
        datasets: _zod.z.array(_zod.z.object({
            label: _zod.z.string(),
            data: _zod.z.array(_zod.z.number().nullable())
        })),
        // True when the underlying result had more groups than the display cap (see
        // emit-page-bound.ts) — only the first cap's worth of labels/data points are shown.
        truncated: _zod.z.boolean()
    })
]);
